import React, { createContext, Component } from 'react';
import PropTypes from 'prop-types';

const MarkerContext = createContext(null);
export default MarkerContext;

export class Provider extends Component {
	constructor(props) {
		super(props);

		this.state = {
			filters: null,
			marker: null,
			stopMarkers: [],
			sharingMarkers: [],
			poiMarkers: [],
			tipMarkers: [],
			parkAndRideMarkers: [],
			vehicleMarkers: [],
			popup: null,
			lines: null,
		};
	}

	shouldComponentUpdate(nextProps, nextState) {
		if (nextState.filters !== this.state.filters) {
			return true;
		}
		if (nextState.marker !== this.state.marker) {
			return true;
		}
		if (nextState.lines !== this.state.lines) {
			return true;
		}
		const types = [
			'stopMarkers',
			'sharingMarkers',
			'poiMarkers',
			'tipMarkers',
			'parkAndRideMarkers',
			'vehicleMarkers',
		];
		const typeCount = types.length;
		//loop checks if changes in marker elements were made and updates the context
		for (let i = 0; i < typeCount; i += 1) {
			//check if next or previous state for types were null and are now set
			if (
				(this.state[types[i]] === null && nextState[types[i]] !== null) ||
				(this.state[types[i]] !== null && nextState[types[i]] === null)
			) {
				return true;
			}
			//if states aren't null
			//first check if arrays have different lengths
			//then check if first element id is different
			//then check if last element id is different
			if (this.state[types[i]] !== null && nextState[types[i]] !== null) {
				if (
					this.state[types[i]].length !== nextState[types[i]].length ||
					(this.state[types[i]].length > 0 &&
						(this.state[types[i]][0].id !== nextState[types[i]][0].id ||
							this.state[types[i]][this.state[types[i]].length - 1].id !==
								nextState[types[i]][nextState[types[i]].length - 1].id))
				) {
					return true;
				}
				//else check if vvsUpdate flag is set on first element
				else if (
					this.state[types[i]].length > 0 &&
					nextState[types[i]][0].vvsUpdate === true
				) {
					//reset flag after one trigger
					nextState[types[i]][0].vvsUpdate = false;
					return true;
				}
			}
		}

		if (JSON.stringify(nextState.popup) !== JSON.stringify(this.state.popup)) {
			return true;
		}
		//if no catches above are made the state is not updating
		return false;
	}

	render() {
		const {
			filters,
			marker,
			stopMarkers,
			sharingMarkers,
			poiMarkers,
			tipMarkers,
			parkAndRideMarkers,
			vehicleMarkers,
			popup,
			lines,
		} = this.state;

		return (
			<MarkerContext.Provider
				value={{
					filters,
					setFilters: newFilters => this.setState({ filters: newFilters }),
					marker,
					setMarker: newMarker => this.setState({ marker: newMarker }),
					stopMarkers,
					setStopMarkers: newStopMarkers =>
						this.setState({ stopMarkers: newStopMarkers }),
					sharingMarkers,
					setSharingMarkers: newSharingMarkers =>
						this.setState({ sharingMarkers: newSharingMarkers }),
					poiMarkers,
					setPoiMarkers: newPoiMarkers => this.setState({ poiMarkers: newPoiMarkers }),
					tipMarkers,
					setTipMarkers: newTipMarkers => this.setState({ tipMarkers: newTipMarkers }),
					parkAndRideMarkers,
					setParkAndRideMarkers: newPRMarkers =>
						this.setState({ parkAndRideMarkers: newPRMarkers }),
					vehicleMarkers,
					setVehicleMarkers: newVehicleMarkers =>
						this.setState({ vehicleMarkers: newVehicleMarkers }),
					popup,
					lines,
					setLines: newLines => this.setState({ lines: newLines }),
					openPopup: (text, options) => {
						if (text === null) {
							this.setState({ popup: null });
						} else {
							this.setState({ popup: { text, options } });
						}
					},
					setContext: updates => this.setState(updates),
				}}
			>
				{this.props.children}
			</MarkerContext.Provider>
		);
	}
}

Provider.propTypes = {
	children: PropTypes.node.isRequired,
};
